import { useMenu, useCan } from "@refinedev/core";
import { ITreeMenu } from "@refinedev/core";
import { logger } from "@utils/logger";

export const useAuthorizedMenu = () => {
    const { menuItems } = useMenu();

    const filterMenuItemsByAuthorization = (items: ITreeMenu[]): ITreeMenu[] => {
        const filteredItems: ITreeMenu[] = [];

        for (const item of items) {
            const { data: canAccess } = useCan({
                resource: item.name,
                action: "list",
            });

            // logger.debug(canAccess?.can)
            if (canAccess?.can) {
                if (item.children && item.children.length > 0) {
                    const filteredChildren = filterMenuItems(item.children);
                    if (filteredChildren.length > 0) {
                        filteredItems.push({
                            ...item,
                            children: filteredChildren,
                        });
                    }
                } else {
                    // logger.debug(item)
                    filteredItems.push(item);
                }
            }
        }

        return filteredItems;
    };

    const filterMenuItems = (items: ITreeMenu[]): ITreeMenu[] => {
        const menuItems =  items.filter(item => item.meta?.mainMenu)
        const authorizedItems = filterMenuItemsByAuthorization(menuItems)
        return authorizedItems;
    }

    const authorizedMenuItems = filterMenuItems(menuItems);

    return {
        menuItems: authorizedMenuItems,
    };
};
